import axios, { AxiosInstance, InternalAxiosRequestConfig } from "axios";

import { MaintenanceModeError } from "./MaintenanceModeError";
import { isMaintenanceModeActive } from "./maintenanceModeState";

let isRegistered = false;

export const createMaintenanceAxiosRequestInterceptor = () => {
  return (config: InternalAxiosRequestConfig) => {
    if (isMaintenanceModeActive()) {
      return Promise.reject(new MaintenanceModeError());
    }

    return config;
  };
};

export const addMaintenanceModeAxiosInterceptor = (instance: AxiosInstance) => {
  instance.interceptors.request.use(createMaintenanceAxiosRequestInterceptor());
};

export interface IMaintenanceFetchRequest {
  url: string;
  config?: RequestInit;
}

export const createMaintenanceFetchInterceptor = () => ({
  request: (request: IMaintenanceFetchRequest) => {
    if (isMaintenanceModeActive()) {
      return Promise.reject(new MaintenanceModeError());
    }

    return request;
  },
});

export const registerMaintenanceApiBlocking = () => {
  if (isRegistered) {
    return;
  }

  isRegistered = true;
  axios.interceptors.request.use(createMaintenanceAxiosRequestInterceptor());
};
